import { render } from "./ElaborarTreinoIndividual.vue?vue&type=template&id=bb4b534a&scoped=true"
import script from "./ElaborarTreinoIndividual.vue?vue&type=script&lang=js"
export * from "./ElaborarTreinoIndividual.vue?vue&type=script&lang=js"

import "./ElaborarTreinoIndividual.vue?vue&type=style&index=0&id=bb4b534a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4b534a"]])

export default __exports__